import { z as e } from "zod";
// src/identity/events.ts
var t = {
	eventId: e.uuid(),
	schemaVersion: e.literal(1),
	aggregateId: e.uuid(),
	aggregateVersion: e.number().int().positive(),
	occurredAt: e.iso.datetime(),
	correlationId: e.uuid()
}, n = e.discriminatedUnion("type", [e.object({
	...t,
	type: e.literal("identity.user-deactivated.v1"),
	payload: e.object({
		userId: e.uuid(),
		reason: e.enum([
			"disabled",
			"deleted",
			"not-employee"
		]),
		effectiveAt: e.iso.datetime()
	}).strict()
}).strict(), e.object({
	...t,
	type: e.literal("identity.user-reactivated.v1"),
	payload: e.object({
		userId: e.uuid(),
		effectiveAt: e.iso.datetime()
	}).strict()
}).strict()]).refine((e) => e.aggregateId === e.payload.userId, "User must match event aggregate"), r = e.enum(/* @__PURE__ */ "identity.role-changed,identity.role-change-refused,teams.team-changed,teams.team-change-refused,teams.membership-changed,teams.membership-change-refused,contacts.contact-changed,contacts.contact-change-refused,customers.customer-created,customers.customer-renamed,customers.customer-archived,customers.customer-reactivated,customers.customer-deleted,customers.assignment-added,customers.assignment-removed,customers.phone-number-added,customers.phone-number-changed,customers.phone-number-removed,customers.customer-change-refused,customers.assignment-change-refused,customers.phone-number-change-refused,customers.dependency-unavailable,schedules.schedule-created,schedules.schedule-renamed,schedules.schedule-archived,schedules.routine-created,schedules.routine-changed,schedules.override-created,schedules.override-changed,schedules.override-canceled,schedules.pending-canceled,schedules.change-refused".split(",")), i = e.object({
	kind: e.enum([
		"user",
		"team",
		"membership",
		"contact",
		"customer",
		"customer-assignment",
		"customer-number",
		"schedule",
		"routine",
		"override"
	]),
	id: e.uuid()
}).strict();
export { n as corporateIdentityEventSchema, r as managementAuditActionSchema, i as managementAuditTargetSchema };

//# sourceMappingURL=events.js.map